export default {
  // Note: the fullTagList is an array of Tag Id Objects,
  //       and the protectedTagList is a object of string Ids
  filterEventTagsByPass(eventsObject, protectedTagList, passList) {
    const checkEventForTag = (evt, tg) => {
      let hasTag = false;
      for (let i = 0; i < evt.tags.length; i++) {
        if (evt.tags[i].id === tg) {
          hasTag = true;
          break;
        }
      }
      return hasTag;
    };

    let eventList;
    if (!Array.isArray(eventsObject)) {
      // convert eventObject to array-based eventsList
      const eventIds = Object.keys(eventsObject);
      eventList = eventIds.map(e => {
        return eventsObject[e];
      });
    } else {
      eventList = eventsObject;
    }

    const protectedTags = Object.keys(protectedTagList);
    let protectedEvents = {};

    // remove all events with projected tags from eventList initially, saved
    // in protectedEvents so they can be added back if allowed
    let filteredEventList = eventList.reduce((arr, event) => {
      let foundTag = null;
      for (let t = 0; t < protectedTags.length; t++) {
        if (checkEventForTag(event, protectedTags[t])) {
          foundTag = protectedTags[t];
          break;
        }
      }

      if (foundTag) {
        protectedEvents[foundTag] = protectedEvents[foundTag] || [];
        protectedEvents[foundTag].push(event);
      } else {
        arr.push(event);
      }

      return arr;
    }, []);

    // check against the list of tag objects and see if
    // tag with a specific string id is in that list
    const listContainsEvent = (list, eventId) => {
      for (let i = 0; i < list.length; i++) {
        if (list[i].id === eventId) {
          return true;
        }
      }
    };

    // interate userPasses and check against each protected tag list
    // and if pass is in the list, add that event back to filteredEventList
    for (let passIndex = 0; passIndex < passList.length; passIndex++) {
      let userPassBucketId = passList[passIndex].pass_bucket.id;
      for (let tagIndex = 0; tagIndex < protectedTags.length; tagIndex++) {
        let tagId = protectedTags[tagIndex];
        if (protectedTagList[tagId].includes(userPassBucketId)) {
          // Make sure filteredEventList does not already include it in a case
          // where the user has multiple passes on the same list
          if (protectedEvents[tagId] && protectedEvents[tagId].length) {
            protectedEvents[tagId].map(evt => {
              if (!listContainsEvent(filteredEventList, evt.id)) {
                filteredEventList.splice(
                  eventList.findIndex(e => e.id === evt.id),
                  0,
                  evt
                );
              }
            });
          }
        }
      }
    }

    // If needed, convert filteredEventList back to an assoc object
    //  with eventIds as keys and return that object
    if (!Array.isArray(eventsObject)) {
      let filteredEventObject = {};
      for (let y = 0; y < filteredEventList.length; y++) {
        const event = filteredEventList[y];
        filteredEventObject[event.id] = event;
      }
      return filteredEventObject;
    } else {
      return filteredEventList;
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/TagUtil.js